import React from 'react';
import { AccordionItem as Item } from '@szhsin/react-accordion';
import Icon from '@common/components/icon';

const AccordionItem = ({
  header,
  total,
  count,
  icon,
  actions,
  customHeader,
  ...rest
}: any) => {
  return (
    <Item
      {...rest}
      header={
        customHeader || (
          <div className="tw-flex tw-flex-row tw-items-center tw-justify-between tw-w-full">
            <div className="tw-flex tw-flex-row tw-items-center tw-gap-1">
              <Icon type="expand_more" className="chevron-down" />
              <h3>{header}</h3>
            </div>
            <div className="tw-flex tw-flex-row tw-items-center tw-gap-1">
              {customHeader}
            </div>
            <div>{actions}</div>
          </div>
        )
      }
    />
  );
};

export default AccordionItem;
